
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/results",
      function () {
        return require("private-next-pages/investor/results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/results"])
      });
    }
  